// removed by extract-text-webpack-plugin
module.exports = {"logo":"PartnershipLogo-logo-fb9957d6"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/PartnershipLogo.scss
// module id = 828
// module chunks = 0